import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FeeCode } from 'src/app/enums/fee.code';
import { Fees } from 'src/app/model/fees';
import { CommonUtil } from 'src/app/services/common.util';

@Component({
    selector: 'app-business-fees',
    templateUrl: './business-fees.component.html',
    styleUrls: ['./business-fees.component.css'],
})
export class BusinessFeesComponent {
    @Input() businessFeeList: Array<Fees>;
    @Input() editBusiness = false;
    @Input() showEditPencil = true;
    @Input() parentToUpdate = false;
    @Input() title = 'business User';
    @Output() updateFee = new EventEmitter();

    feeCode = FeeCode;
    feeLabel = this.commonUtil.getFeeLabels();

    constructor(public commonUtil: CommonUtil) { }

    changeView() {
        this.editBusiness = !this.editBusiness;
    }

    submit() {
        this.updateFee.emit('business');
        this.changeView();
    }


}
